import React, { useState, useEffect, useContext } from "react"

import moment from "moment"
import _ from "lodash"

import { connect } from "react-redux"


import { Button, Form, Row, Col, Space } from "antd"
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons"
import { useLocation, } from "react-router-dom"
import { PageContainer, Xpagination, Xtable, } from "../../../component/Xcomponent"

// Actions
import { getDtrfReportList, getDtrfReportListReset } from "../../../action/getDtrfReportListAction"


//CSS
import { InputBox, XButton } from "./ReportListStyle"
import HeaderContext from "../../../context/HeaderContext"
import { SelectBox } from "../../Appointments/AppointmentList/AppointmentListStyle"
//function
const ReportList = (props) => {
    const {
        getDtrfReportList, getDtrfReportListState, getDtrfReportListReset,

    } = props
    const initialSearchData = {
        search_contain: "",
    }
    const [searchData, setSearchData] = useState(initialSearchData)
    const [refresh, setRefresh] = useState(0)

    const [tableData, setTableData] = useState([])
    const search = useLocation().search
    const page = new URLSearchParams(search).get("page")


    const [pagination, setPagination] = useState({
        page: page ? page : 1,
        records: 10,
    })


    //form
    const [form] = Form.useForm()

    const { setTitle } = useContext(HeaderContext);
    setTitle("Test Reports");

    //columns
    const columns = [
        {
            title: "Patient Name",
            dataIndex: "pname",
            key: "pname",
            render: (data) => (
                <span style={{ fontWeight: 600 }}>{data}</span>
            ),
        },
        {
            title: "Patient Phone",
            dataIndex: "phone",
            key: "phone",
        },
        {
            title: "Test Name",
            dataIndex: "test_name",
            key: "test_name",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Action",
            key: "report",
            dataIndex: "report",
            render: (report) => (
                <Space size="small">
                    {report.length > 0 &&
                        <a
                            href={report[0].location}
                            download
                        >
                            <Button
                                size="small"
                                text="Details"
                                icon={<DownloadOutlined style={{ color: "#883DA9" }} />}
                            />
                        </a>
                    }
                </Space>
            ),
        },
    ]

    // Callback
    useEffect(() => {
        return () => {
            getDtrfReportListReset()
        }

    }, [])

    useEffect(() => {
        getDtrfReportList({
            search_contain: searchData.search_contain,
            page: pagination.page,
            records: pagination.records,
            status: searchData.status, // Pass the status filter
        })
    }, [pagination, refresh])

    useEffect(() => {
        if (getDtrfReportListState.apiState === "success") {
            let tableData = []
            getDtrfReportListState.list.map((data) => {
                tableData.push({
                    pname: `${data.patient[0]?.name?.firstName} ${data.patient[0]?.name?.lastName}`,
                    phone: data.patient[0]?.phone,
                    test_name: data.test_info.display_test_name,
                    status: data.status.status,
                    report: data.report,
                })
            })
            // tableData = _.orderBy(tableData).reverse()
            setTableData(tableData)
        } else if (getDtrfReportListState.apiState === " error") {
        }
    }, [getDtrfReportListState])



    // Function 


    const handleOnChange = (e) => {
        setSearchData({ ...searchData, [e.target.name]: e.target.value })
    }

    // Handle status change for the status filter
    const handleStatusChange = (value) => {
        setSearchData({ ...searchData, status: value });
    };

    //clear filters
    const handleReset = () => {
        form.resetFields()
        setSearchData(initialSearchData)
        setRefresh(refresh + 1)
    }

    //searchfilters
    const searchReport = () => {
        setPagination({ page: 1 })
    }

    return (
        <PageContainer>
            <Form
                form={form}
                onFinish={searchReport}
                layout="vertical"
            >
                <Row gutter={24}>
                    <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <Form.Item
                            name="search_contain"
                        >
                            <InputBox type="text" name="search_contain" onChange={handleOnChange} size="large" placeholder="Search by patient’s name, phone number" prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} className="pl-0">
                        <Space>
                            <Form.Item name="status">
                                <SelectBox
                                    size="large"
                                    autosize={true}
                                    style={{ width: "100%" }}
                                    onChange={handleStatusChange} // Set the status filter change handler
                                    allowClear={true}
                                    placeholder="All status"
                                >
                                    <option value="in_transit">In Transit</option>
                                    <option value="delivered">Delivered</option>
                                    <option value="wip">WIP</option>
                                    <option value="reported">Reported</option>
                                </SelectBox>
                            </Form.Item>
                            <Form.Item name="search_btn">
                                <XButton
                                    className="search_btn borderPrimary"
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Search
                                </XButton>
                            </Form.Item>
                            <Form.Item name="reset_btn">
                                <XButton
                                    className="borderNonPrimary"
                                    type="ghost"
                                    ghost
                                    onClick={() => handleReset()}
                                    size="large"
                                    style={{ width: 100, background: "transparent" }}
                                >
                                    Reset
                                </XButton>
                            </Form.Item>
                        </Space>
                    </Col>
                </Row>
            </Form>

            <div className="Appointment list">
                <Xtable
                    loading={getDtrfReportListState.apiState === "loading"}
                    size="middle"
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                    scroll={{ x: 768 }}
                />
                <Xpagination
                    style={{ gap: "5px", flexWrap: "wrap" }}
                    pageSizeOptions={["10", "25", "50", "100", "500"]}
                    showSizeChanger
                    total={getDtrfReportListState.pagination.total_records}
                    onChange={(page, pageSize) =>
                        setPagination({ page: page, records: pageSize })
                    }
                    current={pagination.page}
                    defaultPageSize={pagination.records}
                    defaultCurrent={1}
                />

            </div>
        </PageContainer >
    )
}

const mapStateToProps = (state) => ({
    getDtrfReportListState: state.getDtrfReportList,
})

const mapDispatchToProps = (dispatch) => ({
    getDtrfReportList: (params) => dispatch(getDtrfReportList(params)),
    getDtrfReportListReset: () => dispatch(getDtrfReportListReset()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReportList)
